import { render, staticRenderFns } from "./OrderCreateDA.vue?vue&type=template&id=504f10fc&scoped=true"
import script from "./OrderCreateDA.vue?vue&type=script&lang=js"
export * from "./OrderCreateDA.vue?vue&type=script&lang=js"
import style0 from "./OrderCreateDA.vue?vue&type=style&index=0&id=504f10fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f10fc",
  null
  
)

export default component.exports